module.exports = __webpack_public_path__ + "img/美容水(蓝)_03.5c4961b2.jpg";